import { parseLocalDate, todayKey, toLocalDateKey } from './dateUtils'

export function getTourShowDateRaw(s: Record<string, unknown>): unknown {
  const v = s.showDate ?? s.show_date
  if (v && typeof v === 'object' && !Array.isArray(v) && !(v instanceof Date)) {
    const o = v as Record<string, unknown>
    if (typeof o.$date === 'string' || typeof o.$date === 'number') return o.$date
  }
  return v
}

/** Coerce API date — `parseLocalDate` alone misses numeric epoch ms and some values Mongoose sends. */
export function coerceTourShowDate(raw: unknown): Date | null {
  if (raw === null || raw === undefined) return null
  if (typeof raw === 'string' && raw.trim() === '') return null
  const pd = parseLocalDate(raw)
  if (pd) return pd
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const t = new Date(raw)
    return Number.isNaN(t.getTime()) ? null : t
  }
  if (raw instanceof Date) return Number.isNaN(raw.getTime()) ? null : raw
  if (typeof raw === 'string') {
    const t = new Date(raw)
    return Number.isNaN(t.getTime()) ? null : t
  }
  return null
}

/** Local calendar day is today or later. */
export function isTodayOrFutureTourShow(s: Record<string, unknown>): boolean {
  const d = coerceTourShowDate(getTourShowDateRaw(s))
  if (!d) return false
  return toLocalDateKey(d) >= todayKey()
}

export function tourShowLabel(s: Record<string, unknown>): string {
  const venue = (s.venue as { city?: string; name?: string } | undefined)?.city || (s.venue as { name?: string } | undefined)?.name
  const artist = (s.showInfo as { artist?: string } | undefined)?.artist
  const d = coerceTourShowDate(getTourShowDateRaw(s))
  const dateStr = d ? d.toLocaleDateString() : '—'
  return [dateStr, venue, artist].filter(Boolean).join(' · ') || 'Tour show'
}
